import{createContext as o}from"react";import{localesEngine as e}from"@ninox/ninox-locales";var t=e,n=t.locale,l=o(t),a=o(n);export{t as a,n as b,l as c,a as d};
//# sourceMappingURL=ninox-components-RBEIDCI6.js.map